module.exports = __webpack_public_path__ + "static/img/bank.97be59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/bank.png
// module id = SEeo
// module chunks = 216